import SCITellUsMoreContainer from './SCITellUsMoreContainer';

export default SCITellUsMoreContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/SCITellUsMore/index.js